import { Helmet } from 'react-helmet-async';

const SITE = 'https://www.jambotravelhouseholidays.com';
const DEFAULT_IMAGE = `${SITE}/Images/safari-social-share.png`;

/**
 * Per-page <head> metadata (title, description, canonical, OpenGraph, Twitter, JSON-LD).
 * Drop near the top of any page component:
 *   <PageMeta title="Kenya Safari Tours" description="…" path="/safaris/kenya" />
 *
 * NOTE: this updates the DOM client-side. It's great for browser tab titles and
 * social scrapers that execute JS, but real crawler SEO still needs the
 * BrowserRouter migration (clean URLs) — see SEO notes in LESSONS.md. The base
 * homepage meta + JSON-LD live in public/index.html for no-JS crawlers.
 */
export default function PageMeta({
  title,
  description,
  path,            // hash-route path, e.g. "/safaris/kenya"
  image = DEFAULT_IMAGE,
  noindex = false,
  structuredData,  // object or array of schema.org JSON-LD
}) {
  const fullTitle = title
    ? `${title} · Jambo Travel House Holidays`
    : 'Jambo Travel House Holidays — Kenya, Tanzania & Rwanda Safari Tours';
  const url = path ? `${SITE}${path}` : `${SITE}/`;
  const ld = structuredData
    ? (Array.isArray(structuredData) ? structuredData : [structuredData])
    : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex, follow" />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Jambo Travel House Holidays" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {ld.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
}
